import { useState } from 'react'
import { apiEtapa6 } from '../api'
import Aviso from '../../components/Aviso'
import { Campo, dataBR } from '../../etapa2/componentes'

const MOTIVOS = [
  ['DOENCA', 'Doença (não relacionada ao trabalho)'],
  ['ACIDENTE_TRABALHO', 'Acidente ou doença do trabalho'],
  ['MATERNIDADE', 'Licença-maternidade'],
  ['PATERNIDADE', 'Licença-paternidade'],
  ['LICENCA_REMUNERADA', 'Licença remunerada'],
  ['LICENCA_NAO_REMUNERADA', 'Licença não remunerada'],
]
const NOME = Object.fromEntries(MOTIVOS)
const vazio = { motivo: 'DOENCA', inicio: '', fim: '', cid: '', data_evento: '', deficiencia: false, empresa_cidada: false, media_variaveis: '', observacao: '' }

export default function Afastamentos({ empresaId }) {
  const [funcionarioId, setFuncionarioId] = useState('')
  const [lista, setLista] = useState([])
  const [form, setForm] = useState(vazio)
  const [detalhe, setDetalhe] = useState(null)
  const [impactos, setImpactos] = useState(null)
  const [filtroImpacto, setFiltroImpacto] = useState({ ano: String(new Date().getFullYear()), pa: '' })
  const [msg, setMsg] = useState({ erro: '', ok: '' })
  const licenca = form.motivo === 'MATERNIDADE' || form.motivo === 'PATERNIDADE'
  const doenca = form.motivo === 'DOENCA' || form.motivo === 'ACIDENTE_TRABALHO'

  async function acao(fn, ok) {
    setMsg({ erro: '', ok: '' })
    try {
      const r = await fn()
      if (ok) setMsg({ erro: '', ok })
      return r
    } catch (e) {
      setMsg({ erro: e.message, ok: '' })
      return undefined
    }
  }
  const carregar = () => acao(async () => setLista(await apiEtapa6.afastamentos(empresaId, funcionarioId)))

  async function registrar() {
    const dados = {
      ...form,
      fim: form.fim || null, cid: form.cid || null, data_evento: form.data_evento || null, media_variaveis: form.media_variaveis || '0',
    }
    const r = await acao(() => apiEtapa6.registrarAfastamento(empresaId, funcionarioId, dados), 'Afastamento registrado.')
    if (r) {
      setDetalhe({ afastamento: r })
      setForm(vazio)
      carregar()
    }
  }
  async function verS2230(af) {
    const s = await acao(() => apiEtapa6.s2230(empresaId, funcionarioId, af.afastamento_id))
    if (s) setDetalhe({ afastamento: af, s2230: s })
  }
  async function alta(af) {
    const fim = window.prompt('Data da alta (último dia afastado), AAAA-MM-DD')
    if (!fim) return
    const r = await acao(() => apiEtapa6.encerrarAfastamento(empresaId, funcionarioId, af.afastamento_id, fim), 'Alta registrada.')
    if (r) {
      setDetalhe({ afastamento: r })
      carregar()
    }
  }
  async function excluir(af) {
    await acao(() => apiEtapa6.excluirAfastamento(empresaId, funcionarioId, af.afastamento_id), 'Afastamento excluído.')
    setDetalhe(null)
    carregar()
  }
  async function verImpactos() {
    const r = await acao(() => apiEtapa6.impactos(empresaId, funcionarioId, filtroImpacto.ano, filtroImpacto.pa))
    if (r) setImpactos(r)
  }

  return (
    <section>
      <h2>Afastamentos e licenças</h2>
      <p className="fundamento">
        Doença e acidente (15 primeiros dias pela empresa e mesma doença em 60 dias), licença-maternidade e licença-paternidade
        (Lei 15.371/2026: 10 dias a partir de 2027, salário-paternidade compensado). Gera os campos do S-2230 com as regras da
        NT S-1.3 07/2026 e confere a estabilidade nas rescisões.
      </p>
      <div className="grade">
        <Campo rotulo="Matrícula do funcionário"><input value={funcionarioId} onChange={(e) => setFuncionarioId(e.target.value)} /></Campo>
      </div>
      <div className="acoes"><button className="secundario" disabled={!empresaId || !funcionarioId} onClick={carregar}>Carregar afastamentos</button></div>

      {lista.length > 0 && (
        <table>
          <thead><tr><th>Motivo</th><th>Início</th><th>Fim</th><th>CID</th><th>Prazo S-2230</th><th>Estabilidade até</th><th /></tr></thead>
          <tbody>
            {lista.map((a) => (
              <tr key={a.afastamento_id}>
                <td>{NOME[a.motivo]}</td><td>{dataBR(a.inicio)}</td><td>{a.fim_previsto ? dataBR(a.fim_previsto) : 'em aberto'}</td><td>{a.cid || ''}</td>
                <td>{a.s2230_dispensado ? 'dispensado' : dataBR(a.prazo_s2230)}</td><td>{dataBR(a.estabilidade_ate)}</td>
                <td>
                  <button className="link" onClick={() => verS2230(a)}>S-2230</button>
                  {!a.fim_previsto && <button className="link" onClick={() => alta(a)}>informar alta</button>}
                  <button className="link" onClick={() => excluir(a)}>excluir</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <fieldset>
        <legend>Novo afastamento</legend>
        <div className="grade">
          <Campo rotulo="Motivo">
            <select value={form.motivo} onChange={(e) => setForm({ ...form, motivo: e.target.value })}>
              {MOTIVOS.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
            </select>
          </Campo>
          <Campo rotulo="Início"><input type="date" value={form.inicio} onChange={(e) => setForm({ ...form, inicio: e.target.value })} /></Campo>
          <Campo rotulo={licenca ? 'Fim (vazio = duração legal)' : 'Fim (vazio = em aberto)'}><input type="date" value={form.fim} onChange={(e) => setForm({ ...form, fim: e.target.value })} /></Campo>
          {doenca && <Campo rotulo="CID (dado sensível)"><input value={form.cid} placeholder="J11" onChange={(e) => setForm({ ...form, cid: e.target.value.toUpperCase() })} /></Campo>}
          {licenca && <Campo rotulo="Data do parto ou adoção"><input type="date" value={form.data_evento} onChange={(e) => setForm({ ...form, data_evento: e.target.value })} /></Campo>}
          {licenca && <Campo rotulo="Média de variáveis (remuneração integral)"><input type="number" step="0.01" min="0" value={form.media_variaveis} onChange={(e) => setForm({ ...form, media_variaveis: e.target.value })} /></Campo>}
          <Campo rotulo="Observação"><input value={form.observacao} onChange={(e) => setForm({ ...form, observacao: e.target.value })} /></Campo>
        </div>
        {licenca && (
          <div className="grade">
            <label className="inline"><input type="checkbox" checked={form.empresa_cidada} onChange={(e) => setForm({ ...form, empresa_cidada: e.target.checked })} /> Empresa Cidadã (prorrogação paga pela empresa)</label>
            {form.motivo === 'PATERNIDADE' && <label className="inline"><input type="checkbox" checked={form.deficiencia} onChange={(e) => setForm({ ...form, deficiencia: e.target.checked })} /> Criança com deficiência (+1/3)</label>}
          </div>
        )}
        <div className="acoes"><button disabled={!empresaId || !funcionarioId || !form.inicio} onClick={registrar}>Registrar</button></div>
      </fieldset>
      <Aviso>{msg.erro}</Aviso>
      <Aviso tipo="ok">{msg.ok}</Aviso>

      {detalhe && <Detalhe {...detalhe} />}

      <fieldset>
        <legend>Impactos no 13º e nas férias</legend>
        <div className="grade">
          <Campo rotulo="Ano"><input type="number" value={filtroImpacto.ano} onChange={(e) => setFiltroImpacto({ ...filtroImpacto, ano: e.target.value })} /></Campo>
          <Campo rotulo="Início do período aquisitivo (opcional)"><input type="date" value={filtroImpacto.pa} onChange={(e) => setFiltroImpacto({ ...filtroImpacto, pa: e.target.value })} /></Campo>
        </div>
        <div className="acoes"><button className="secundario" disabled={!empresaId || !funcionarioId} onClick={verImpactos}>Calcular impactos</button></div>
        {impactos && <ul className="memoria">{impactos.memoria.map((m, i) => <li key={i}>{m}</li>)}</ul>}
      </fieldset>
    </section>
  )
}

function Detalhe({ afastamento: a, s2230 }) {
  return (
    <div className="holerite">
      <h3>{NOME[a.motivo]} · {dataBR(a.inicio)} a {a.fim_previsto ? dataBR(a.fim_previsto) : 'em aberto'}</h3>
      <p className="fundamento">
        {a.dias ? `${a.dias} dias` : 'Duração em aberto'}
        {a.dias_empresa_cidada ? ` (inclui ${a.dias_empresa_cidada} dias de Empresa Cidadã)` : ''}
        {a.dias_empresa_ja_pagos ? ` · empresa já pagou ${a.dias_empresa_ja_pagos} dias na mesma doença` : ''}
        {a.info_mesmo_motivo ? ` · infoMesmoMtv = ${a.info_mesmo_motivo}` : ''}
        {' · '}S-2230: {a.s2230_dispensado ? 'envio dispensado' : `enviar até ${dataBR(a.prazo_s2230)}`}
        {a.estabilidade_ate ? ` · estabilidade até ${dataBR(a.estabilidade_ate)}` : ''}
      </p>
      {a.avisos?.length > 0 && <div className="aviso"><ul>{a.avisos.map((x, i) => <li key={i}>{x}</li>)}</ul></div>}
      {s2230 && (
        <>
          {s2230.ocorrencias.length > 0 && (
            <div className="aviso"><ul>{s2230.ocorrencias.map((o, i) => <li key={i}><strong>{o.severidade}</strong>: {o.mensagem}</li>)}</ul></div>
          )}
          <pre className="payload">{JSON.stringify(s2230.dados, null, 2)}</pre>
          {s2230.eventos_adicionais?.map((ev, i) => (
            <div key={i}>
              <p className="fundamento">Outro S-2230 (prorrogação, código {ev.codMotAfast}):</p>
              <pre className="payload">{JSON.stringify(ev, null, 2)}</pre>
            </div>
          ))}
        </>
      )}
    </div>
  )
}
